<template>
    <!-- Nav -->
			<nav id="nav">
				<ul class="container">
					<li><a href="#level">LEVEL</a></li>
					<li><a href="#word">단어</a></li>
					<li><a href="#work">퀴즈</a></li>
					<li><a href="#grade">채점결과</a></li>
					<li><a href="#contact">문의</a></li>
				</ul>
			</nav>
		<!-- level -->
		<article id="level" class="wrapper style2">
				<div class="container">
					<header>
						<h1>난이도 선택</h1>
						<p>단어 초기화 시간: {{ timeUntilMidnight }}</p>
					</header>
					<div class="row aln-center">
						<div class="col-4 col-6-medium col-12-small">
							<section class="box style1"  @click="changeLevel(1)">
								<h3>LEVEL1 (초등수준)</h3>
							</section>
						</div>
						<div class="col-4 col-6-medium col-12-small">
							<section class="box style1"  @click="changeLevel(2)">
								<h3>LEVEL2 (중 · 고등수준)</h3>
							</section>
						</div>
						<div class="col-4 col-6-medium col-12-small">
							<section class="box style1"  @click="changeLevel(3)">
								<h3>LEVEL3 (전문)</h3>
							</section>
						</div>
						<div class="col-4 col-6-medium col-12-small">
							<section class="box style1"  @click="changeLevel(4)">
								<h3>LEVEL4 (토익)</h3>
							</section>
						</div>
						
					</div>
					<footer>
						<p>난이도 : {{ level }}</p>
						<a href="#work" class="button large scrolly">문제풀러가기</a>
					</footer>
				</div>
			</article>

		<!-- Work -->
			<article id="work" class="wrapper style2">
				<div class="container">
					<header>
						<h1 v-if="quizSeq < 10">Quiz {{ quizSeq + 1 }} / 10</h1>
						<h1 v-else>Quiz 10 / 10</h1>
						<h3><p>{{word[quizNumber]}} ?</p></h3>
						<p v-if="_isViewAnswer2">정답 : {{ ko[quizNumber] }}</p>
					</header>
					<div class="row aln-center">
						<div class="col-4 col-6-medium col-12-small">
							<section class="box Quiz" @click="AnserQuzi(0)" :class="{ 'correct': _isCorrect01, 'incorrect': _isCorrect01===false }">
								<h3>{{ko[randomAnswer[0]]}}</h3>
							</section>
						</div>
						<div class="col-4 col-6-medium col-12-small">
							<section class="box Quiz" @click="AnserQuzi(1)" :class="{ 'correct': _isCorrect02, 'incorrect': _isCorrect02===false }">
								<h3>{{ko[randomAnswer[1]]}}</h3>
							</section>
						</div>
						<div class="col-4 col-6-medium col-12-small">
							<section class="box Quiz" @click="AnserQuzi(2)" :class="{ 'correct': _isCorrect03, 'incorrect': _isCorrect03===false }">
								<h3>{{ko[randomAnswer[2]]}}</h3>
							</section>
						</div>
						
					</div>
					<footer>
						<a href="#grade" class="button large scrolly" v-if="this.quizSeq >= 9" @click="exitQuiz()">채점 하기</a>
						<a class="button" v-else @click="changeQuiz();">다음문제</a>
					</footer>
				</div>
			</article>

				<!-- 단어1 -->
			<article id="word" class="wrapper style2">
				<div class="container">
					<div class="row">
						<div class="word-list1">
						<header>
							<h1>{{ word[currentPage * 6 - 6] }}</h1>
							<p v-if="_isViewAnswer" class="long-text1">{{ ko[currentPage * 6 - 6] }}</p>
							<p v-else>&nbsp;</p>
						</header>
						<header>
							<h1>{{ word[currentPage * 6 - 5] }}</h1>
							<p v-if="_isViewAnswer" class="long-text1">{{ ko[currentPage * 6 - 5] }}</p>
							<p v-else>&nbsp;</p>
						</header>
						<header>
							<h1>{{ word[currentPage * 6 - 4] }}</h1>
							<p v-if="_isViewAnswer" class="long-text1">{{ ko[currentPage * 6 - 4] }}</p>
							<p v-else>&nbsp;</p>
						</header>
						</div>
						<div class="word-list2">
						<header>
							<h1>{{ word[currentPage * 6 - 3] }}</h1>
							<p v-if="_isViewAnswer" class="long-text2">{{ ko[currentPage * 6 - 3] }}</p>
							<p v-else>&nbsp;</p>
						</header>
						<header>
							<h1>{{ word[currentPage * 6 - 2] }}</h1>
							<p v-if="_isViewAnswer" class="long-text2">{{ ko[currentPage * 6 - 2] }}</p>
							<p v-else>&nbsp;</p>
						</header>
						<header>
							<h1>{{ word[currentPage * 6 - 1] }}</h1>
							<p v-if="_isViewAnswer" class="long-text2">{{ ko[currentPage * 6 - 1] }}</p>
							<p v-else>&nbsp;</p>
						</header>
						</div>
					</div>
					<div class="page-container" >
						<div>
							<button class="prevButton"  @click="prevPage" :disabled="currentPage === 1">prev</button>
							<span>{{ currentPage }} / {{ pageCount }}</span>&nbsp;
							<button class="nextButton"  @click="nextPage" :disabled="currentPage === pageCount">next</button>
						</div>
					</div>
					<div class="page-container">
						<div style="margin-top: 10px;">
							<button class="answer-class" @click="toggleAnswer"><span>답안지</span></button>
						</div>
					</div>
					
			</div>
		</article>

		<!-- 채점결과 -->
			<article id="grade" class="wrapper style3">
				<div class="container">
					<header>
						<h2>채점결과</h2>
						<p>{{ quizSeq - wrongAnswer.length }} / {{ quizSeq }}</p>
					</header>

					<header>
						<h4>맞춘문제</h4>
					</header>
					<div class="row">
							<div v-for="(answer, index) in answer" :key="index" class="col-4 col-6-medium col-12-small">
							<article class="box style2">
								<h3>{{word[answer]}}</h3>
								<p>{{ko[answer]}}</p>
							</article>
						</div>
					</div>

					<header>
						<h4>틀린문제</h4>
					</header>
					<div class="row">
							<div v-for="(answer, index) in wrongAnswer" :key="index" class="col-4 col-6-medium col-12-small">
							<article class="box style2">
								<h3>{{word[answer]}}</h3>
								<p>{{ko[answer]}}</p>
							</article>
						</div>
					</div>
					<footer>
						<a href="#work" class="button large scrolly" @click="init()">문제다시풀기</a>
					</footer>
				</div>
			</article>

		<!-- Contact -->
			<article id="contact" class="wrapper style4">
				<div class="container medium">
					<header>
						<h2>Have me make stuff for you.</h2>
						<p>Ornare nulla proin odio consequat sapien vestibulum ipsum.</p>
					</header>
					<div class="row">
						<div class="col-12">
							<form method="post" action="#">
								<div class="row">
									<div class="col-6 col-12-small">
										<input type="text" name="name" id="name" placeholder="Name" />
									</div>
									<div class="col-6 col-12-small">
										<input type="text" name="email" id="email" placeholder="Email" />
									</div>
									<div class="col-12">
										<input type="text" name="subject" id="subject" placeholder="Subject" />
									</div>
									<div class="col-12">
										<textarea name="message" id="message" placeholder="Message"></textarea>
									</div>
									<div class="col-12">
										<ul class="actions">
											<li><input type="submit" value="Send Message" /></li>
											<li><input type="reset" value="Clear Form" class="alt" /></li>
										</ul>
									</div>
								</div>
							</form>
						</div>
						<div class="col-12">
							<hr />
							<h3>Find me on ...</h3>
							<ul class="social">
								<li><a href="#" class="icon brands fa-twitter"><span class="label">Twitter</span></a></li>
								<li><a href="#" class="icon brands fa-facebook-f"><span class="label">Facebook</span></a></li>
								<li><a href="#" class="icon brands fa-dribbble"><span class="label">Dribbble</span></a></li>
								<li><a href="#" class="icon brands fa-linkedin-in"><span class="label">LinkedIn</span></a></li>
								<li><a href="#" class="icon brands fa-tumblr"><span class="label">Tumblr</span></a></li>
								<li><a href="#" class="icon brands fa-google-plus"><span class="label">Google+</span></a></li>
								<li><a href="#" class="icon brands fa-github"><span class="label">Github</span></a></li>
								<!--
								<li><a href="#" class="icon solid fa-rss"><span>RSS</span></a></li>
								<li><a href="#" class="icon brands fa-instagram"><span>Instagram</span></a></li>
								<li><a href="#" class="icon brands fa-foursquare"><span>Foursquare</span></a></li>
								<li><a href="#" class="icon brands fa-skype"><span>Skype</span></a></li>
								<li><a href="#" class="icon brands fa-soundcloud"><span>Soundcloud</span></a></li>
								<li><a href="#" class="icon brands fa-youtube"><span>YouTube</span></a></li>
								<li><a href="#" class="icon brands fa-blogger"><span>Blogger</span></a></li>
								<li><a href="#" class="icon brands fa-flickr"><span>Flickr</span></a></li>
								<li><a href="#" class="icon brands fa-vimeo"><span>Vimeo</span></a></li>
								-->
							</ul>
							<hr />
						</div>
					</div>
					<footer>
						<ul id="copyright">
							<li>&copy; Untitled. All rights reserved.</li><li>Design: <a href="http://html5up.net">HTML5 UP</a></li>
						</ul>
					</footer>
				</div>
			</article>
</template>

<script>
/* eslint-disable */ 
import indexMethods from '@/scripts/index.js'
export default {
  name: 'index',
  data() {
        return {
          level: '4', //난이도
          word:[], // 단어
          ko:[], // 해석
		  currentPage: 1, // 현재 페이지 번호
		  pageCount: 5,
		  _isViewAnswer: false, //단어 답안 활성화여부
		  _isViewAnswer2: false, //퀴즈 답안 활성화여부
		  quizNumber: 0, //퀴즈번호
		  ranNumber1: 0, 
		  ranNumber2: 0, 
		  randomAnswer:[], //답난수
		  quizSeq:0, // 진행중인 퀴즈
		  wrongAnswer:[], //틀린답안
		  answer:[], //맞춘답안
		  quizList:[], //진행된 퀴즈
		  seoulTime: '', //서울시간
		  timeUntilMidnight: '', //자정까지남은시간
		  _isCorrect01: '',
		  _isCorrect02: '',
		  _isCorrect03: '',
		  _isCorrect: '',
        };
      },
  created(){
    this.search01();
  },
  mounted(){
	this.getSeoulTime();
	setInterval(this.getSeoulTime, 1000); // 1초마다 시간을 업데이트
  },
  methods: {
	  init(){
		this.quizSeq = 0;
		this.answer = [];
		this.wrongAnswer = []; //틀린답안
		this.quizNumber = 0;
		this.ranNumber1 = 0;
		this.ranNumber2 = 0;
		this.randomAnswer = [];
		this.quizList = [];
		this._isViewAnswer2 = false;
		this._isCorrect01 = '';
		this._isCorrect02 = '';
		this._isCorrect03 = '';
		this._isCorrect = '';
		this.createAnswer();
	  },
      search01() {
          try { 
            indexMethods.methods.search01(this.level, (res) => {
                  if(res.status === 200){
                    for (let i = 0; i < 30; i++) {
                      this.word[i] = res.data[i].word;
                      this.ko[i] = res.data[i].ko;
                    }
                    this.createAnswer();
                  }
              },
              (error) => { // 에러 콜백
                  console.error("검색 오류:", error);
              });
        } catch (error) {
          console.error("검색 오류:", error);
        }
      },
	  changeLevel(level) {
        this.level = level;
		alert('난이도가 변경되었습니다.');
		this.init();
		this.search01();
      },
	  AnserQuzi(choice){
		if(this.quizSeq > 9){
			alert('문제는 10문항까지 입니다.');
			return;
		}
		if(!this._isViewAnswer2){
			if(choice !== this.ranNumber1){
				this.wrongAnswer[this.wrongAnswer.length] = this.quizNumber;
				this._isCorrect = false;
				if (choice === 0) {
					this._isCorrect01 = false;
				} else if (choice === 1) {
					this._isCorrect02 = false;
				} else if (choice === 2) {
					this._isCorrect03 = false;
				}
			}else {
				this.answer[this.answer.length] = this.quizNumber;
				this._isCorrect = true;
				if (choice === 0) {
					this._isCorrect01 = true;
				} else if (choice === 1) {
					this._isCorrect02 = true;
				} else if (choice === 2) {
					this._isCorrect03 = true;
				}
			}
			this.quizList[this.quizSeq] = this.quizNumber;
			this._isViewAnswer2 = true;
		}
	  },
	  changeQuiz(){ 
		this.quizSeq += 1;
		this._isViewAnswer2 = false;
		this._isCorrect01 = '';
		this._isCorrect02 = '';
		this._isCorrect03 = '';
		this._isCorrect = '';
		this.createAnswer();
	  },
	  exitQuiz(){ 
		this.quizSeq += 1;
	  },
	  createAnswer(){ //문제생성
		this.quizNumber = Math.floor(Math.random() * 29);
		for(let i = 0; i < this.quizList.length; i ++){
			while(true){ //문제생성
				if(this.quizList[i] !==this.quizNumber) break;
				else this.quizNumber = Math.floor(Math.random() * 29);
			}
		}
		this.ranNumber1 = Math.floor(Math.random() * 3);
		this.randomAnswer[this.ranNumber1] = this.quizNumber;
		for(let i = 0; i < 3; i ++){
			if(this.ranNumber1 === i ) continue;
			else {
				this.ranNumber2 = Math.floor(Math.random() * 29);
				if(this.ranNumber2 === this.ranNumber1){
					this.ranNumber2 = Math.floor(Math.random() * 29);
				}
				if(i !== this.ranNumber1) {
					for(let j = 0 ; j < this.randomAnswer.length; j ++){
						while(true){ //답안지생성
							if(this.randomAnswer[j] !==this.ranNumber2) break;
							else this.ranNumber2 = Math.floor(Math.random() * 29);
						}
					}
					this.randomAnswer[i] = this.ranNumber2;
				}
			}
		}
	  },
	  nextPage() {
		if (this.currentPage < this.pageCount) {
				this.currentPage++;
			}
		},
		prevPage() {
			if (this.currentPage > 1) {
				this.currentPage--;
			}
		},
		toggleAnswer() {
        	this._isViewAnswer = !this._isViewAnswer;
     	},
		 getSeoulTime() {
			const now = new Date();
			const seoulTime = now.toLocaleTimeString("en-US", {timeZone: "Asia/Seoul", hour12: false});
      		this.seoulTime = seoulTime;

			// 자정까지 남은 시간 계산
			const midnight = new Date(now);
			midnight.setHours(24, 0, 0, 0); // 오늘 자정 설정
			const timeDiff = Math.max(midnight - now, 0);
			const hours = Math.floor(timeDiff / (1000 * 60 * 60));
			const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
			const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
			this.timeUntilMidnight = `${hours}:${minutes}:${seconds}`;
		},
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.correct {
    background-color: #78c7d2; /* 파란색 */
}

.incorrect {
    background-color: rgb(241, 118, 118); /* 빨간색 */
}
</style>

<style src="../css/index.css" scoped></style>